import React from 'react';
import Icon from '../../../components/AppIcon';

const MobileTabNavigation = ({ tabs, activeTab, onTabChange, isMenuOpen, onMenuToggle }) => {
  const activeTabData = tabs.find(tab => tab.id === activeTab);

  return (
    <div className="bg-white/70 backdrop-blur-sm rounded-lg shadow-lg border border-blue-100">
      {/* Menu Toggle Button */}
      <button
        onClick={onMenuToggle}
        className="w-full flex items-center justify-between p-4 focus:outline-none focus:bg-blue-50 transition-colors duration-200"
        aria-expanded={isMenuOpen}
      >
        <div className="flex items-center space-x-3">
          <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center">
            <Icon name={activeTabData?.icon} size={16} className="text-blue-600" />
          </div>
          <span className="font-medium text-slate-800">{activeTabData?.label}</span>
        </div>
        <Icon 
          name="ChevronDown" 
          size={20} 
          className={`text-slate-500 transition-transform duration-200 ${
            isMenuOpen ? 'rotate-180' : ''
          }`} 
        />
      </button>

      {/* Dropdown Menu */}
      {isMenuOpen && (
        <div className="border-t border-blue-100 bg-white rounded-b-lg">
          <div className="py-2">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => onTabChange(tab.id)}
                className={`w-full flex items-center space-x-3 px-4 py-3 text-left transition-colors duration-200 ${
                  tab.id === activeTab
                    ? 'bg-blue-50 text-blue-600 border-r-2 border-blue-600' :'text-slate-600 hover:text-slate-800 hover:bg-blue-50'
                }`}
              >
                <div className={`w-6 h-6 rounded-md flex items-center justify-center ${
                  tab.id === activeTab 
                    ? 'bg-blue-600' :'bg-slate-200'
                }`}>
                  <Icon 
                    name={tab.icon} 
                    size={14} 
                    className={tab.id === activeTab ? 'text-white' : 'text-slate-600'} 
                  />
                </div>
                <span className="font-medium">{tab.label}</span>
                {tab.id === activeTab && (
                  <Icon name="Check" size={16} className="text-blue-600 ml-auto" />
                )}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default MobileTabNavigation;